import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken, isRtl } from 'src/helper/tool'
import http from 'src/helper/http'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import localstorage from 'src/helper/localstorage'
import Toast from 'src/component/Toast'
import ShowModal from 'src/component/showModal'
import Loading from 'src/component/Loading'
import { history } from 'src/core/router'
import { toJS } from 'mobx'

import RoomGold from './RoomGold'
import ReportTitle from './ReportTitle'
import ReportTitle2 from './ReportTitle2'
import AdminRoomList from './adminRoomList'
import Sign from './Sign'
import Owner from './Owner'
import GetUsers from './GetUsers'
import LastWeekAward from './LastWeekAward'
import AwardUserList from './AwardUserList'

@inject('store')
@observer
export default class extends React.Component {
  constructor(props) {
    super(props)
    this.roomsupportStore = this.props.store.register('app/roomsupport')
  }
  state = {
    loading: false,
    lang: langM.ar,
    deleteRommItemId: null,
    roomList: [],
    roomShow: false,
    language:'en',
  }

  async componentWillMount() {
    let { language } = this.props.location.query
    await this.getRoomList()
    language =await getlang(language)
    console.log('language', language)
    this.setState({
      lang: setlang(language, langM),
      language: language
    })
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  async RunOnStart(uid) {
    this.roomsupportStore.GroupSupper()
    this.roomsupportStore.GroupAdmins()
  }

  componentWillReceiveProps() {
    console.log('componentWillReceiveProps')
    // this.roomsupportStore.GroupAdmins()
  }

  // getDerivedStateFromProps() {
  //   console.log('getDerivedStateFromProps')
  // }

  componentDidUpdate() {
    console.log('componentDidUpdate')
    let { editUsers } = this.props.location.query
    if (editUsers == 1) {
      setTimeout(() => {
        let title = this.getUsersSet()
        setDocumentTitle(this.state.lang.RSetting.replace('AAA', title))
      }, 100)
    } else {
      setDocumentTitle(this.state.lang.title)
    }
  }

  hideToast = async (status) => {
    this.refs.toast.hideRule(status)
  }
  getRoomList = async () => {
    let res = await http.post('/web/GroupSupper/group/mysupport')
    if (res.code == 0 && res.res) {
      let roomShow = res.res.length > 0 ? true : false
      this.setState({
        roomList: res.res,
        roomShow
      })

    }
  }
  GroupSupperApply = async () => {
    let d = await this.roomsupportStore.GroupSupperApply()
    if (d.code == 0) {
      this.roomsupportStore.setToastContent(this.state.lang.signSuccess)
      this.hideToast(true)
    } else if (d.code == 2004) {
      // console.log(this.state.lang.haveSign)
      this.roomsupportStore.setToastContent(this.state.lang.signSuccess + '.')
      this.hideToast(true)
    }
  }
  //删除管理房间
  deleteRommItem = (id) => {
    this.refs.toast1.hideRule(true)
    this.setState({
      deleteRommItemId: id
    })
    console.log('控制弹窗',)
    /* this.roomsupportStore.delectRoomItem(id) */
  }
  //取消删除房间
  ShowModalnOclick = () => {
    console.log('取消删除')
    this.setState({
      deleteRommItemId: null
    })
    this.refs.toast1.hideRule(false)
  }
  ShowModalDeltItem = (id) => {
    this.roomsupportStore.delectRoomItem(this.state.deleteRommItemId)
    this.setState({
      roomList: []
    })
    this.render()
    this.refs.toast1.hideRule(false)
    this.refs.roomList.hideRule()
  }
  setEditUsers = async (status) => {
    //请先报名
    let { GroupSupper } = this.roomsupportStore.data
    if (GroupSupper.canApply && !GroupSupper.applied) {
      this.roomsupportStore.setToastContent(this.state.lang.noticeBeforeEdit)
      this.refs.toast.hideRule(true)
      return
    }

    // console.log(111, GroupSupper)
    if (
      GroupSupper.applied &&
      GroupSupper.lastWeekRecord &&
      GroupSupper.lastWeekRecord.status &&
      GroupSupper.lastWeekRecord.status == 2
    ) {
      this.roomsupportStore.setToastContent(this.state.lang.noticeBeforeEditWithSign)
      this.refs.toast.hideRule(true)
      return
    }

    if (status) {
      let title = this.getUsersSet()
      setDocumentTitle(this.state.lang.RSetting.replace('AAA', title))
      let { uid, accesstoken } = localstorage.get('userInfo')
      this.roomsupportStore.setAdmins()
      history.push(`/app/roomsupport-op?editUsers=1&uid=${uid}&accesstoken=${accesstoken}`)
    }
  }

  setOrder = (uid) => {
    this.roomsupportStore.setOrder(uid)
    let title = this.getUsersSet()
    setDocumentTitle(this.state.lang.RSetting.replace('AAA', title))
  }

  getUsersSet = () => {
    let a = 0
    let b = 0
    if (this.roomsupportStore.data.admins && this.roomsupportStore.data.admins) {
      let admins = toJS(this.roomsupportStore.data.admins)
      for (let i = 0; i < admins.length; i++) {
        if (admins[i].idx > 0) {
          a++
        }
        if (admins[i].canSelect == 1) {
          b++
        }
      }
      return a + '/' + 10
    }
    return '0/10'
  }

  UpdateRewordMembers = async () => {
    let { language } = this.state
    let d = await this.roomsupportStore.UpdateRewordMembers()
    if (d.code == 0) {
      console.log('reload')
      setDocumentTitle(this.state.lang.title)
      this.roomsupportStore.GroupSupper()
      this.roomsupportStore.GroupAdmins()
      window.history.go(-1)
      // history.push(`/app/roomsupport-op`)
    } else {
      if (d.msg == 'Your application is under review' && language == 'tr') {
        d.msg = 'Başvurunuz incelemede'
      } else if (d && d.code && d.code == 2003) {
        this.roomsupportStore.setToastContent(this.state.lang.noticeBeforeEditWithSign)
      }
      if (d.msg != '') {
        this.roomsupportStore.setToastContent(d.msg)
      }
      this.refs.toast.hideRule(true)
      this.roomsupportStore.GroupSupper()
      this.roomsupportStore.GroupAdmins()
    }
  }

  render() {
    let language = this.state.language
    // language = 'tr'
    let { uid } = localstorage.get('userInfo')
    let { roomShow } = this.state
    uid = parseInt(uid)
    let {
      loading,
      displayBtn,
      toastContent,
      GroupSupper,
      includeOwner,
      canSelectOwner,
      admins,
      otherDgid,
      otherGid,
      haveSign,
    } = this.roomsupportStore.data
    let { editUsers } = this.props.location.query
    if (editUsers == 1) {
      editUsers = true
    } else {
      editUsers = false
    }
    return (
      <div className={`roomsupport ${isRtl(language) && 'arlang'}`}>
        {/* 房间流水 */}
        {!editUsers && <RoomGold language={language} lang={this.state.lang} GroupSupper={GroupSupper} />}

        {/* 报名条件 */}
        {!editUsers && !GroupSupper.canApply && (
          <ReportTitle
            language={language}
            lang={this.state.lang}
            cancelReward={(gid) => {
              this.roomsupportStore.cancelReward(gid)
            }}
            otherGid={otherGid}
            otherDgid={otherDgid}
            canSelectOwner={canSelectOwner}
          />
        )}



        {/* 上周奖励 */}
        {!editUsers && haveSign && (
          <LastWeekAward language={language} lang={this.state.lang} lastWeekRecord={GroupSupper.lastWeekRecord} />
        )}

        {/* 房主 */}
        {!editUsers && GroupSupper.canApply && (
          <Owner language={language} lang={this.state.lang} owner={GroupSupper.owner} />
        )}

        {/* 可领取用户 */}
        {!editUsers && GroupSupper.canApply && (
          <GetUsers
            language={language}
            lang={this.state.lang}
            members={GroupSupper.members}
            setEditUsers={() => {
              this.setEditUsers(true)
            }}
          />
        )}
        {/* 管理列表 */}
        {!editUsers && roomShow && (
          <AdminRoomList
            ref="roomList"
            language={language}
            lang={this.state.lang}
            roomList={this.state.roomList}
            deltItem={this.deleteRommItem}
          />
        )}
        {/* 规则说明 */}
        {!editUsers && GroupSupper.canApply && <ReportTitle2 language={language} lang={this.state.lang} />}

        {/* 报名按钮 */}

        {!editUsers && (
          <Sign
            language={language}
            lang={this.state.lang}
            GroupSupper={GroupSupper}
            displayBtn={displayBtn}
            GroupSupperApply={() => {
              this.GroupSupperApply()
            }}
          />
        )}
        {/* 编辑用户 */}
        {editUsers && (
          <AwardUserList
            language={language}
            lang={this.state.lang}
            admins={admins || []}
            setIncludeOwner={() => {
              this.roomsupportStore.setIncludeOwner()
            }}
            cancelReward={(gid) => {
              this.roomsupportStore.cancelReward(gid)
            }}
            includeOwner={includeOwner}
            canSelectOwner={canSelectOwner}
            otherDgid={otherDgid}
            otherGid={otherGid}
            UpdateRewordMembers={() => {
              this.UpdateRewordMembers()
            }}
            setOrder={this.setOrder.bind(this)}
          />
        )}
        {/* 交互弹窗 */}
        <ShowModal language={language} lang={this.state.lang} onHendle={this.ShowModalnOclick} determineHendle={this.ShowModalDeltItem} ref="toast1" id="toast" />
        {/* 浮窗提示 */}
        <Toast language={language} lang={this.state.lang} ref="toast" id="toast" toastContent={toastContent} />
        <Loading ref="loading" id="loading" status={loading} />
        <div className="cache">
          <img src="/img/app/roomsupport/open.png" />
          <img src="/img/app/roomsupport/close.png" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/roomsupport-op/index.js